import { dataLinkAlt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLinkAlt = /*#__PURE__*/createIcon(dataLinkAlt)
export default IconLinkAlt
